const rutasContexto = [

  //Version 1
  // carros
  // cerramientoUrbanismo * no se usa
  // comunal
  // duplicadores
  // urbanismoSauces
  // urbanismoFelicidad
  // vegetacionFelicidad
  // edificiosVecinos * no tiene textura

  //Version 2
  //rampaAccesoVehicular * tiene alpha
  //pastoInterior
  //contexto1
  //contexto2
  //anden
  //adoquinContexto1
  //adoquinContexto2
  //adoquinUrbanismo
  //cerramientoConjunto

  //Version3
  //adoquin 
  //arbustos 
  //materas 
  //carretera 



  //Modelos

  
  {
    name: "modelo_comunal",
    type: "gltfModel",
    path: "modelos/contexto/COMUNAL_FL.gltf",
  },
  {
    name: "modelo_cerramientoUrbanismo",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/CERRAMIENTO URBANISMO_FL.gltf",
  },
  {
    name: "modelo_cerramientoUrbanismo2",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/CERRAMIENTO_URBANISMO-2.gltf",
  },
  {
    name: "modelo_urbanismoSauces",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/URBANISMO SAUCES_FL.gltf",
  },
  {
    name: "modelo_urbanismoGeneral",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/URBANISMO.gltf",
  },
  {
    name: "modelo_adoquinContexto",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/ADOQUIN_CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_edificiosVecinos",
    type: "gltfModel",
    path: "modelos/contexto/EDIFICIOS_VECINOS.gltf",
  },
  {
    name: "modelo_contexto2",
    type: "gltfModel",
    path: "modelos/contexto/CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_adoquinContexto2",
    type: "gltfModel",
    path: "modelos/contexto/ADOQUIN_CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_carretera",
    type: "gltfModel",
    path: "modelos/contexto/CARRETERA_FL.gltf",
  },
  {
    name: "modelo_fondoMapa",
    type: "gltfModel",
    path: "modelos/contexto/FONDO_MAPAS BOGOTA_FL.gltf",
  },  
  /*
  
    
  
  {
    name: "modelo_cerramientoConjunto",
    type: "gltfModel",
    path: "modelos/contexto/CERRAMIENTO CONJUNTO_FL.gltf",
  },
  
  
  {
    name: "modelo_rampaAccesoVehicular",
    type: "gltfModel",
    path: "modelos/contexto/RAMPA_ACCESO VEHICULAR_FL.gltf",
  },
  {
    name: "modelo_pastoInterior",
    type: "gltfModel",
    path: "modelos/contexto/PASTO_INTERIOR_FL.gltf",
  },
  {
    name: "modelo_contexto1",
    type: "gltfModel",
    path: "modelos/contexto/CONTEXTO_01_FL.gltf",
  },
    
  {
    name: "modelo_anden",
    type: "gltfModel",
    path: "modelos/contexto/ANDEN_FL.gltf",
  },
  
  
  {
    name: "modelo_adoquinUrbanismo",
    type: "gltfModel",
    path: "modelos/contexto/ADOQUIN_UNRBANISMO LA FELICIDAD_FL.gltf",
  },
  {
    name: "modelo_adoquin",
    type: "gltfModel",
    path: "modelos/contexto/ADOQUIN_FL.gltf",
  },
  {
    name: "modelo_arbustos",
    type: "gltfModel",
    path: "modelos/contexto/ARBUSTOS_FL.gltf",
  },
  {
    name: "modelo_materas",
    type: "gltfModel",
    path: "modelos/contexto/MATERAS_FL.gltf",
  },
  */
  //Texturas  
  {
    name: "text_comunal",
    type: "texture",
    path: "texturas/contexto/COMUNAL_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_urbanismoSauces",
    type: "texture",
    path: "texturas/contexto/nuevo/URBANISMO SAUCES_FL_Corona_Diffuse2.webp",
    
    
  },
  {
    name: "text_cerramientoUrbanismo",
    type: "texture",
    path: "texturas/contexto/nuevo/CERRAMIENTO URBANISMO_FL_Corona_Diffuse1.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo_alpha",
    type: "texture",
    path: "texturas/contexto/nuevo/CERRAMIENTO URBANISMO_FL_Corona_Alpha.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo2",
    type: "texture",
    path: "texturas/contexto/nuevo/FL_CERRAMIENTO CONJUNTO_2.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo2_alpha",
    type: "texture",
    path: "texturas/contexto/nuevo/FL_CERRAMIENTO_CONJUNTO_ALPHA.webp",
    
  },
  {
    name: "text_urbanismoGeneral",
    type: "texture",
    path: "texturas/contexto/nuevo/URBANISMO LA FELICIDAD_FL_Corona_Diffuse2.webp",
  },
  {
    name: "text_adoquinContexto",
    type: "texture",
    path: "texturas/contexto/nuevo/ADOQUIN_UNRBANISMO LA FELICIDAD_FL_Corona_Diffuse_2.webp",
  },
  {
    name: "text_contexto2",
    type: "texture",
    path: "texturas/contexto/CONTEXTO_02_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_adoquinContexto2",
    type: "texture",
    path: "texturas/contexto/ADOQUIN_CONTEXTO_02_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_carretera",
    type: "texture",
    path: "texturas/contexto/CARRETERA_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_fondoMapa",
    type: "texture",
    path: "texturas/contexto/FONDO_MAPAS BOGOTA_FL_Corona_Diffuse2.webp",
  },


  /*
  {
    name: "text_duplicadores",
    type: "texture",
    path: "texturas/contexto/DUPLICADORES_FL_Corona_Diffuse.webp",
  },
  
  {
    name: "text_urbanismoFelicidad",
    type: "texture",
    path: "texturas/contexto/URBANISMO LA FELICIDAD_FL_Corona_Diffuse.webp",
  },
  
  
  
  {
    name: "text_rampaAccesoVehicular",
    type: "texture",
    path: "texturas/contexto/RAMPA_ACCESO VEHICULAR_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_rampaAccesoVehicular_alpha",
    type: "texture",
    path: "texturas/contexto/RAMPA_ACCESO VEHICULAR_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_pastoInterior",
    type: "texture",
    path: "texturas/contexto/PASTO_INTERIOR_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_contexto1",
    type: "texture",
    path: "texturas/contexto/CONTEXTO_01_FL_Corona_Diffuse.webp",
  },
  
  {
    name: "text_anden",
    type: "texture",
    path: "texturas/contexto/ANDEN_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_adoquinContexto1",
    type: "texture",
    path: "texturas/contexto/ADOQUIN_CONTEXTO_01_FL_Corona_Diffuse.webp",
  },
  
  {
    name: "text_adoquinUrbanismo",
    type: "texture",
    path: "texturas/contexto/ADOQUIN_UNRBANISMO LA FELICIDAD_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_cerramientoConjunto",
    type: "texture",
    path: "texturas/contexto/CERRAMIENTO CONJUNTO_FL_Corona_Diffuse.webp",
  },
  
  {
    name: "text_adoquin",
    type: "texture",
    path: "texturas/contexto/ADOQUIN_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_arbustos",
    type: "texture",
    path: "texturas/contexto/ARBUSTOS_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_materas",
    type: "texture",
    path: "texturas/contexto/MATERAS_FL_Corona_Diffuse.webp",
  },
  
  
  */
];

export default rutasContexto;
